import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Paper from "components/Paper";
import Text from "components/Text";
import Button from "components/Button";
import { Calendar, utils } from "components/Calender";
import TimeSlot from "components/TimeSlot";
import { reportError } from "crashlytics";
import Loader from "assets/images/calendar-loading.gif"

import clsx from "clsx";
import styles from "./index.module.css";

import { writeToStorage, readFromStorage } from "../../utils/storage";
import { QueryKeys } from "common/constants";
import { useGetAvailableTimeSlots, useReserve } from "queries/service";

const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
};

const Step6 = () => {
    const history = useHistory();
    //-----------filters , state, handlers starts here --------------//
    const defaultValue = {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate(),
    };
    const [selectedDay, setSelectedDay] = useState(defaultValue);
    const [selectedTime, setSelectedTime] = useState();
    //-----------------end of filter, state, handlers--------------------//

    //----------start data---------------//

    const departmentName = readFromStorage(QueryKeys.department);
    const serviceName = readFromStorage(QueryKeys.service);
    

    let query = useQuery();
    const serviceId = query.get("service_id") ||  readFromStorage(QueryKeys.serviceId);
    // eslint-disable-next-line no-unused-vars
    const { data, isLoading, isError } = useGetAvailableTimeSlots(serviceId || 0);

    const calendarData = () => {
        if (data?.length > 0) {
            let calenderData = data.map((item) => (
                item?.date
            )) || []
            calenderData = [...new Set(calenderData)]
            const dateObj = (date) => {
                return { year: new Date(date).getFullYear(), month: new Date(date).getMonth() + 1, day: new Date(date).getDate(), className: "activeDay" }
            }
            calenderData = calenderData.map(dateObj)

            return calenderData
        }
    }

    const groupByDate = (array, key) => {
        return array.reduce((result, currentValue) => {
            (result[`${currentValue.date}`] = result[currentValue.date] || []).push(
                currentValue
            );
            return result;
        }, {});
    };

    const timeData = () => {
        if (data?.length > 0) {
            let timeData = data.map((item) => (
                { [item?.date]: item?.interval }
            )) || []
            const timeObj = (item) => {
                return { time: item?.interval?.start, className: "activeTime" }
            }
            timeData = groupByDate(data, "date")
            const date = `${selectedDay?.year}-${selectedDay?.month > 9 ? selectedDay?.month : '0' + selectedDay?.month}-${selectedDay?.day > 9 ? selectedDay?.day : '0' + selectedDay?.day}`;
            timeData = timeData[date]
            if (timeData) {
                timeData = timeData.map(timeObj)
                return timeData
            }
            return []
        }
    }

    const {
        mutateAsync: reserve,
    } = useReserve();

    const onSubmit = async () => {
        try {
            const result = await reserve({
                date: `${selectedDay?.year}-${selectedDay?.month > 9 ? selectedDay?.month : '0' + selectedDay?.month}-${selectedDay?.day > 9 ? selectedDay?.day : '0' + selectedDay?.day}`,
                time: selectedTime && selectedTime,
                service_id: serviceId,
            });
            if (result) {
                history.push(`/programare/step7?appointment_id=${result?.appointment_id}`);
            }
        } catch (error) {
            reportError("Step6: onSubmit: error: ", error);
        }
    };
    //----------end data---------------//

    useEffect(() => {
        setSelectedTime()
    }, [selectedDay]);

    return (
        <div className={styles.step6Page}>
            <div className={styles.pageHeader}>
                <Text type={"h3"}>Pasul 3 din 5</Text>
                <Text type={"h1"}>
                    {departmentName} / {serviceName}
                </Text>
            </div>
            <Paper className={styles.paper}>

                <div className={clsx(styles.row, styles.spaceBtw)}>
                    <div className={styles.leftContainer}>
                        {isLoading && (
                            <div className={styles.loaderContainer}>
                                <img src={Loader} alt="image1" className="logo" />
                            </div>
                        )}
                        <Text type={"h3"}>Alege data programării</Text>
                        <Calendar
                            value={selectedDay}
                            onChange={(value) => {
                                setSelectedDay(value);
                                writeToStorage(QueryKeys.date, `${value?.year}-${value?.month > 9 ? value?.month : '0' + value?.month}-${value?.day > 9 ? value?.day : '0' + value?.day}`);
                            }}
                            minimumDate={utils().getToday()}
                            shouldHighlightWeekends
                            customDaysClassName={calendarData()}

                        />
                    </div>
                    <div className={styles.rightContainer}>
                        <Text type={"h3"}>Alege ora programării</Text>
                        <TimeSlot
                            value={selectedTime}
                            onChange={(value) => {
                                setSelectedTime(value);
                                writeToStorage(QueryKeys.time, value);
                            }}
                            customTimeClassName={timeData()}
                        />
                    </div>
                </div>
                <div
                    className={clsx(
                        styles.actionContainer,
                        styles.alignCenter,
                        styles.spaceBtw
                    )}
                >
                    <Button
                        className={styles.prevButton}
                        size="large"
                        variant="secondary"
                        label="<- înapoi"
                        onClick={history.goBack}
                    />
                    <Button
                        className={styles.nextButton}
                        size="large"
                        label="Continuă ->"
                        disabled={!selectedTime}
                        onClick={() => onSubmit()}
                    />
                </div>
            </Paper>
        </div>
    );
};

export default Step6;
